<mat-card-header
  flex
  layout-align="space-between end"
  class="edit-note-header"
  layout="row"
>
  <mat-card-title
    class="edit-screen-card-title"
    [translate]="'historyLog.note.editNote'"
  >
    Edit note
  </mat-card-title>
  <button tabindex="-1" mat-icon-button (click)="onNoClick()">
    <mat-icon>clear</mat-icon>
  </button>
</mat-card-header>

@for (note of notes; track note) {
  <div>
    <h4>
      {{ 'claims.createDate' | translate }}:
      {{ note.createdAt | itfgDateFormat }}
    </h4>
    <itfg-note
      [noteToEdit]="note"
      [mode]="noteModes.EDIT"
    ></itfg-note>
  </div>
}
